module.exports = __webpack_public_path__ + "assets/images/D-Icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/D-Icon.png
// module id = 1352
// module chunks = 1